@if (footerHtml) {
  <div class="welo-footer-custom" [innerHTML]="footerHtml | safeHtml"></div>
} @else if (logoUrl) {
  <div
    class="flex flex-col bg-primary-800 justify-center items-center h-32 min-w-full gap-2 mt-16">
    <img [src]="logoUrl" height="20px" width="55px" alt="logo" />
    <div class="h-10 flex justify-center items-center">
      <p
        (keypress)="openDialogMoreInfo('300ms', '300ms')"
        (click)="openDialogMoreInfo('300ms', '300ms')"
        class="text-2xs text-purple-50 font-medium cursor-pointer">
        Términos y condiciones
      </p>
    </div>
  </div>
}
